interface Config {
  apiUrl: string;
  environment: string;
  cloudflareAccountId: string;
  mainDomain: string;
  isProduction: boolean;
  isStaging: boolean;
  isDevelopment: boolean;
}

const config: Config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  cloudflareAccountId: import.meta.env.VITE_CLOUDFLARE_ACCOUNT_ID || '',
  mainDomain: import.meta.env.VITE_MAIN_DOMAIN || 'localhost',
  isProduction: import.meta.env.VITE_ENVIRONMENT === 'production',
  isStaging: import.meta.env.VITE_ENVIRONMENT === 'staging',
  isDevelopment: import.meta.env.VITE_ENVIRONMENT === 'development',
};

export default config; 